import { redirectToInternalLink } from "./redirectHelper";

// Global message handler to avoid multiple listeners
let messageHandler = null;

/**
 * Initialize notification message handling
 * This listens for messages from the service worker and handles notification clicks
 *
 * @param {Function} navigate - React Router navigate function
 * @param {string} eventSlug - The current event slug
 */
export const initializeNotificationMessageHandler = (navigate, eventSlug) => {
  // Remove existing listener if any
  if (messageHandler) {
    navigator.serviceWorker.removeEventListener("message", messageHandler);
  }

  // Create new message handler
  messageHandler = (event) => {
    if (event.data.type === "NOTIFICATION_CLICK") {
      handleNotificationClickMessage(event.data.data, navigate, eventSlug);
    } else {
    }
  };

  // Add the new listener
  navigator.serviceWorker.addEventListener("message", messageHandler);
};

/**
 * Handle notification click message from service worker
 *
 * @param {Object} data - The notification data
 * @param {Function} navigate - React Router navigate function
 * @param {string} eventSlug - The current event slug
 */
const handleNotificationClickMessage = async (data, navigate, eventSlug) => {
  const { link_type, to_type, to_id } = data;

  if (link_type === "internal" && to_type && to_id) {
    try {
      await redirectToInternalLink(to_type, to_id, eventSlug, navigate);
    } catch (error) {}
  } else {
  }
};
